//React And GLOBAL CSS
import React, { useEffect, useState } from 'react';
import GConf from './AssetsM/generalConf';
import LoadingBar from 'react-top-loading-bar'
import { toast, ToastContainer } from 'react-toastify';

//logIn & Landing 
import InputLoginPage from './Commande/loginPage'
import InputLandingPage from './Commande/commandeLanding'


//ajouter commande
import NouveauxCommande from "./Commande/NCommande/nouveauxCommande";

//mes commandes
import CommandePage from './Commande/MCommandes/commandePage';
import CommandeEdit from './Commande/MCommandes/commandeEdit';
import CommandeInfo from "./Commande/MCommandes/commandesInfo"

// Catalogue 
import FamilleList from "./Commande/Catalogue/FamilleList";
import Famille from './Commande/Catalogue/Famille';
import ArticleInfo from './Commande/Catalogue/ArticleInfo';
import ArticleList from './Commande/Catalogue/ArticleList';
import ArticlePhoto from './Commande/Catalogue/ArticlePhoto';

//clients
import ClientsPage from "./Commande/Clients/clientData";
import ClientPointage from './Commande/Clients/clientPointage';
import ClientMap from './Commande/Clients/clientMap';
import ClientList from './Commande/Clients/clientList';
import AddClient from './Commande/Clients/addClient';

//uploade
import UploadeCommandePage from './Commande/Upload/updatePage';
import RecettePage from './Commande/Recette/recettePage';
import StatPage from './Commande/Statistic/statPage';
import ClientData from './Commande/Clients/clientData';
import PannierCommande from './Commande/NCommande/pannierCommande';

// /*CSS*/
import 'bootstrap-icons/font/bootstrap-icons.css';
import './theme.css';
import "gridjs/dist/theme/mermaid.css";
import 'react-toastify/dist/ReactToastify.css';

//Router & Routes
import { BrowserRouter as Router,Routes,Route, Outlet} from "react-router-dom";
import { Navigate } from 'react-router-dom';
import { Button } from 'semantic-ui-react';
 
function App() {
 
  const [progress, setProgress] = useState(2)

  //useefeects
  useEffect(() => {
    setProgress(100);
  }, []);

  
  const NotFound = () =>{
    return (<div className="cpntainer text-danger pt-5 text-center">
             <h1>Page Introuvable 404 </h1>
            <Button onClick={() =>  window.location.href = "/C"}>Page d'acuile </Button>
        </div>);
  }

  const RedirectingPage = () => {
    const CommandeIsLogged = localStorage.getItem(`${GConf.SystemTag}_Cmd_LocalD`);
    return (<>
        {
            CommandeIsLogged ? <Navigate to='/C'  /> : <Navigate to='/logIn'  />
        } 
</>);}
  
  return (
    <>
      <Router>
        <Routes>
           <Route path="" exact element={<RedirectingPage />} />
            <Route path="logIn" exact element={<InputLoginPage />} />
            <Route path="C" exact element={<Outlet />} >
                    <Route path="" exact element={<InputLandingPage />} />
                    <Route path="cm" exact element={<NouveauxCommande />} />
                    <Route path="cm/pannier" exact element={<PannierCommande />} />
                    <Route path="mc" exact element={<Outlet />} >
                        <Route path="" exact element={<CommandePage />} />
                        <Route path="modifier/:CID" exact element={<CommandeEdit />} />
                        <Route path="info/:CID" exact element={<CommandeInfo />} />
                    </Route>
                    <Route path="cg" exact element={<Outlet />} >
                        <Route path="" exact element={<ArticleList />} />
                        <Route path="info/:AID" exact element={<ArticleInfo />} />
                        <Route path="familles" exact element={<Famille />} />
                        <Route path="familles/:genre" exact element={<FamilleList />} />
                        <Route path="ajout-ph" exact element={<ArticlePhoto />} />
                    </Route>
                    <Route path="cl" exact element={<Outlet />} >
                        <Route path="" exact element={<ClientsPage />} />
                        <Route path="ajouter" exact element={<AddClient />} />
                        <Route path="recherche" exact element={<ClientMap />} />
                        <Route path="pointage" exact element={<ClientPointage />} />
                        <Route path="List" exact element={<ClientList />} />
                        <Route path="info/:CID" exact element={<ClientData />} />
                    </Route>
                    <Route path="rt" exact element={<RecettePage />} />
                    <Route path="stat" exact element={<StatPage />} />
                    <Route path="up" exact element={<UploadeCommandePage />} />
            </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>   
      </Router>
      <LoadingBar color={GConf.themeColor} progress={progress}  
                //onLoaderFinished={() => setProgress(0)} 
      />
      <ToastContainer />
    </>
    
  );
}

export default App;
